import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import PaymentReportingOptInPage from './component';
import paths from '@renter-hub/pathsManifest';
import { requestPaymentReportingOptIn } from '@renter-hub/actions/requests';
import { saveDateOfBirth, saveFirstName, saveLastName } from '../../../../shared/renter-hub/actions/onboarding';
import { showModalNotification, showPageNotification } from '@common/actions/NotificationActions';
import { PAYMENT_REPORTING_OPT_IN_SUCCESS } from '@renter-hub/constants/notifications';

const mapStateToProps = (state, { fromDashboard }) => {
  const { onboarding, dashboard } = state.payments.renter;
  const { firstName, lastName } = dashboard.renterProfile;
  const { addressInfo } = dashboard.rentTerms;
  const { transactions } = dashboard.paymentHistory;
  const hasPaymentHistory =
    transactions?.length > 0 &&
    transactions.some(
      (transaction) =>
        transaction.paymentCategory === 'rentPayment' &&
        (transaction.renterStatus === 'complete' || transaction.renterStatus === 'manual'),
    );
  const user = state.user;

  const { firstDueDate } = dashboard.rentTerms;
  const accountOpenDate = firstDueDate ? new Date(firstDueDate) : new Date();

  const accountOpenDateFormatted = {
    year: accountOpenDate.getUTCFullYear(),
    month: accountOpenDate.getUTCMonth() + 1,
    day: accountOpenDate.getUTCDate(),
  };

  const optInPayload = {
    rentTermsKey: dashboard.rentTerms.rentTermsKey,
    dateOfBirth: onboarding.dateOfBirth,
    firstName,
    lastName,
    street: addressInfo.homeAddress,
    city: addressInfo.city,
    state: addressInfo.state,
    zip: addressInfo.zipCode,
    unit: addressInfo.unit,
    paymentDurationInMonths: dashboard.rentTerms.numberOfPayments,
    accountOpenDate: accountOpenDateFormatted,
    isFixedRentTerm: !dashboard.rentTerms.monthToMonth,
    // default reportHistorical to true if coming from dashboard
    reportHistorical: fromDashboard && hasPaymentHistory ? undefined : false,
  };

  return {
    fromDashboard,
    alreadyEnrolled: dashboard.paymentReporting?.optedIn,
    optInPayload,
    hasPaymentHistory,
    user,
    listingAlias: dashboard.listingAlias,
    firstName,
    lastName,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl, fromDashboard }) => ({
  saveDateOfBirth: (dateOfBirth) => dispatch(saveDateOfBirth(dateOfBirth)),
  saveFirstName: (firstName) => dispatch(saveFirstName(firstName)),
  saveLastName: (lastName) => dispatch(saveLastName(lastName)),
  requestPaymentReportingOptIn: async (optInPayload) => {
    const optInResponse = await dispatch(requestPaymentReportingOptIn(optInPayload));
    return { error: optInResponse.payload.error };
  },
  showSuccessNotification: () => dispatch(showPageNotification(PAYMENT_REPORTING_OPT_IN_SUCCESS)),
  showSuccessModal: () => dispatch(showModalNotification(PAYMENT_REPORTING_OPT_IN_SUCCESS)),
  continueToNextPage: () => {
    const nextPage = fromDashboard ? baseUrl : baseUrl + paths.paymentInfoPage;
    dispatch(push(nextPage));
  },
  goToDashboard: async () => {
    await dispatch(push(baseUrl));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentReportingOptInPage);
